import { Link } from "react-router-dom";

function LocationPin() {
  return (
    <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M6 0C3.79 0 2 1.79 2 4c0 3 4 8.5 4 8.5S10 7 10 4c0-2.21-1.79-4-4-4Zm0 5.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z" fill="currentColor" />
    </svg>
  );
}

type EventCard = {
  title: string;
  location: string;
  image: string;
};

const EVENTS: readonly EventCard[] = [
  {
    title: "healthcon, pazcare",
    location: "Bengaluru",
    image: "/homepage/Invite1.webp",
  },
  {
    title: "Oasis, IIM ",
    location: "Ahmedabad",
    image: "/homepage/Invite2.webp",
  },
  {
    title: "openai education summit",
    location: "Bengaluru",
    image: "/homepage/Invite3.webp",
  },
  {
    title: "navonmesh",
    location: "Bhopal",
    image: "/homepage/Invite4.webp",
  },
  {
    title: "ai for business owners",
    location: "Noida",
    image: "/homepage/Invite5.webp",
  },
  {
    title: "publicis sapient",
    location: "Bengaluru",
    image: "/homepage/Invite6.webp",
  },
];



function EventTile({
  event,
  className,
}: {
  event: EventCard;
  className?: string;
}) {
  return (
    <div
      className={`relative overflow-hidden rounded-2xl border border-white/10 ${className ?? ""}`}
    >
      <img
        src={event.image}
        alt={event.title}
        className="absolute inset-0 h-full w-full object-cover"
        loading="lazy"
        decoding="async"
      />
      <div className="absolute bottom-0 left-0 right-0 flex items-center justify-between gap-3 bg-black/70 px-4 py-2.5 text-white backdrop-blur-sm">
        <span className="font-fira text-xs font-normal uppercase tracking-[0.12em] md:text-sm">
          {event.title}
        </span>
        <span className="flex items-center gap-1.5 font-fira text-xs text-white/80 md:text-sm">
          <LocationPin />
          <span className="uppercase tracking-[0.08em]">{event.location}</span>
        </span>
      </div>
    </div>
  );
}

export default function InviteSection() {
  return (
    <section
      id="invite-speaker"
      className="w-full bg-black py-14 font-fira text-white sm:py-20 scroll-mt-24"
      aria-labelledby="invite-section-heading"
    >
      <div className="mx-auto w-[90%] md:w-[80%]">
        {/* Heading */}
        <div className="flex flex-col gap-6 md:flex-row md:items-start md:justify-between md:gap-10">
          <div className="max-w-2xl text-left">
            <p className="font-fira text-sm font-normal uppercase tracking-[0.18em] text-white">
              Speaking &amp; workshops
            </p>
            <h2
              id="invite-section-heading"
              className="mt-3 font-fira-condensed text-[30px] font-medium leading-tight tracking-tight text-white md:mt-4 md:text-[42px]"
            >
              Vaibhav on your stage
            </h2>
            <p className="mt-3 font-fira text-sm font-normal leading-relaxed text-[#FFFFFF85] md:mt-4 md:text-base">
              If you&apos;re organizing an event, planning a company session, or
              hosting a podcast and want Vaibhav to speak, this is where that
              conversation starts.
            </p>
          </div>

          <Link
            to="/invite-as-speaker"
            className="shrink-0 self-start md:mt-9 rounded-lg border border-[#FFFFFF4D] bg-transparent px-6 py-3 text-center text-sm font-medium text-white transition hover:bg-white/5 md:px-8"
          >
            Invite as Speaker
          </Link>
        </div>

        {/* Grid — 3 columns on desktop, stacked on mobile */}
        <div className="mt-10 flex flex-col gap-4 md:mt-12 md:flex-row md:gap-5">
          {/* Column 1 — 25% */}
          <div className="flex flex-col gap-4 md:w-1/4 md:gap-5">
            <EventTile event={EVENTS[0]} className="h-[450px] md:h-[380px]" />
            <EventTile event={EVENTS[3]} className="h-[180px] md:h-[185px]" />
          </div>

          {/* Column 2 — 25% */}
          <div className="flex flex-col gap-4 md:w-1/4 md:gap-5">
            <EventTile event={EVENTS[1]} className="h-[180px] md:h-[185px]" />
            <EventTile event={EVENTS[4]} className="h-[400px] md:h-[380px]" />
          </div>

          {/* Column 3 — 50% */}
          <div className="flex flex-col gap-4 md:w-1/2 md:gap-5">
            <EventTile event={EVENTS[2]} className="h-[260px] md:h-[385px]" />
            <EventTile event={EVENTS[5]} className="h-[180px] md:h-[175px]" />
          </div>
        </div>
      </div>

    </section>
  );
}
